import React, { PureComponent, lazy, Suspense } from "react";
import { Breadcrumb } from "antd";
import "./index.css";
import Nav from "components/Nav";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { userRouter } from "./fieldConfig";
// import Request from "../../../networkReq/request";
// import Http from "../../../networkReq/http"
// import { Message } from 'element-react';
// import { getToken, getUserId } from "utils/storage";

export default class UserCenter extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      token: null,
      userId: null,
      status: "",
      defaultActive: "1",
      pathMap: {},
    };
  }

  componentWillMount() {
    // const userId = getUserId();
    // const token = getToken();
    let pathMap = {};
    userRouter.map((item) => {
      let key = this.getComptName(item.path).pop();
      pathMap[key] = item.title;
    });

    this.setState({
      pathMap,
    });
  }

  getComptName(path) {
    let arr = path.split("/entrance/recruitEnterprise/").pop().split("/");
    arr.length > 2 && arr.pop();
    return arr;
  }

  getComptPath(title) {
    let path = "";
    userRouter.forEach((item) => {
      if (item.title == title) {
        path = item.path;
      }
    });
    return path;
  }

  createRoute = (routeConfig) => {
    const arr = [];
    routeConfig.map((item, index) => {
      if (item.children && item.children.length > 0) {
        this.createRoute(item.children);
      }
      arr.push(
        // 子路由需要在父路由的基础上加一级路由时  需要加 extra  否则子路由无法匹配
        <Route path={item.path} exact component={item.component} key={index} />
      );
    });
    return arr;
  };
  goto = (params) => {
    // window.history.back()
    window.location.reload();
  };
  // 获取实名认证详情
  // getPersonalUserAuthDetail(userId) {
  //     let params = {
  //         userId: userId
  //     };
  //     return Http.post(Request.personalUserAuthDetail(), params, obj => {
  //         console.log('obj', obj);
  //         if (obj.data && obj.code == 200) {
  //             if(obj.data.authenticationStatus == 2){
  //                 this.setState({ status: '审核中' })
  //             }
  //         }
  //     });
  // }

  render() {
    const { defaultActive, pathMap } = this.state;
    const { location, history } = this.props;
    // let title = pathMap[this.getComptName(location.pathname)]
    let titleArr = this.getComptName(location.pathname).map(
      (item) => pathMap[item]
    );
    return (
      <div className="userCenter personal">
        <div className="container clear">
          <div className="breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item>机构中心</Breadcrumb.Item>
              {titleArr.length &&
                titleArr.map((title, index) => {
                  return index == titleArr.length - 1 ? (
                    <Breadcrumb.Item className="active">
                      {title}
                    </Breadcrumb.Item>
                  ) : (
                    <Breadcrumb.Item>
                      <a onClick={() => history.push(this.getComptPath(title))}>
                        {title}
                      </a>
                    </Breadcrumb.Item>
                  );
                })}
            </Breadcrumb>
          </div>
          <div className="personal_content">
            <Suspense fallback={<div>Loading...</div>}>
              {this.createRoute(userRouter)}
              <Redirect
                from="/entrance/recruitEnterprise"
                to="/entrance/recruitEnterprise/enterpriseInfo"
              />
            </Suspense>
          </div>
        </div>
      </div>
    );
  }
}
